// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml from "../../../../../node_modules/rescript/lib/es6/caml.js";
import * as List from "../../../../../node_modules/rescript/lib/es6/list.js";
import * as $$Array from "../../../../../node_modules/rescript/lib/es6/array.js";
import * as BadgeUtils from "../../utils/BadgeUtils.bs.js";
import * as Caml_array from "../../../../../node_modules/rescript/lib/es6/caml_array.js";
import * as Belt_Option from "../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as RewardMilestone from "../../domain/types/RewardMilestone.bs.js";
import * as RnrModalsHelper from "../helpers/RnrModalsHelper.bs.js";
import * as ErrorUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";

function getSortedMilestones(rnrState) {
  return List.sort((function (a, b) {
                return Caml.caml_int_compare(a.points, b.points);
              }), rnrState.milestones);
}

function getTotalPoints(lst) {
  if (lst) {
    return lst.hd.points + getTotalPoints(lst.tl) | 0;
  } else {
    return 0;
  }
}

function getMilestoneVM(rnrState) {
  var totalPoints = getTotalPoints(rnrState.cycleCategoryAgg);
  var milestoneStatus = {
    contents: /* Star */0
  };
  var nextMilestone = {
    contents: /* BronzeHero */1
  };
  var secondNextMilestone = {
    contents: /* BronzeSuperStar */2
  };
  var pointsOfCurrentMilestone = {
    contents: 0
  };
  var awardOfCurrentMilestone = {
    contents: undefined
  };
  var pointsToNextMilestone = {
    contents: 0
  };
  var pointsToSecondNextMilestone = {
    contents: 0
  };
  var showLocked = {
    contents: false
  };
  var sortedMilestones = getSortedMilestones(rnrState);
  var sortedMilestoneArray = $$Array.of_list(sortedMilestones);
  var $$break = {
    contents: false
  };
  List.iteri((function (index, milestone) {
          if (!$$break.contents) {
            if (totalPoints >= milestone.points && index === (List.length(sortedMilestones) - 1 | 0)) {
              milestoneStatus.contents = milestone.name;
              pointsOfCurrentMilestone.contents = milestone.points;
              awardOfCurrentMilestone.contents = milestone.award;
              nextMilestone.contents = milestone.name;
              secondNextMilestone.contents = milestone.name;
              return ;
            } else if (totalPoints >= milestone.points && totalPoints < Caml_array.get(sortedMilestoneArray, index + 1 | 0).points) {
              milestoneStatus.contents = milestone.name;
              pointsOfCurrentMilestone.contents = milestone.points;
              awardOfCurrentMilestone.contents = milestone.award;
              nextMilestone.contents = Caml_array.get(sortedMilestoneArray, index + 1 | 0).name;
              pointsToNextMilestone.contents = Caml_array.get(sortedMilestoneArray, index + 1 | 0).points - totalPoints | 0;
              if (index === (List.length(sortedMilestones) - 2 | 0)) {
                secondNextMilestone.contents = Caml_array.get(sortedMilestoneArray, index + 1 | 0).name;
                pointsToSecondNextMilestone.contents = Caml_array.get(sortedMilestoneArray, index + 1 | 0).points - totalPoints | 0;
              } else {
                secondNextMilestone.contents = Caml_array.get(sortedMilestoneArray, index + 2 | 0).name;
                pointsToSecondNextMilestone.contents = Caml_array.get(sortedMilestoneArray, index + 2 | 0).points - totalPoints | 0;
              }
              showLocked.contents = index < (List.length(sortedMilestones) - 3 | 0);
              $$break.contents = true;
              return ;
            } else {
              return ;
            }
          }
          
        }), sortedMilestones);
  var milestones = List.map((function (milestone) {
          return {
                  name: milestone.name,
                  points: milestone.points
                };
        }), sortedMilestones);
  var getClaimedMilestonesVM = List.map((function (milestone) {
          var award = milestone.award;
          return {
                  milestoneBadge: BadgeUtils.getBadge(milestone.name),
                  milestone: milestone.name,
                  milestoneName: RewardMilestone.toUrlString(milestone.name),
                  award: award !== undefined ? award : ErrorUtils$Catalyst.raiseError("MilestoneVM.getMilestoneVM.getClaimedMilestoneVM", "No award found", "")
                };
        }), List.filter(function (milestone) {
              return milestone.award !== undefined;
            })(List.rev(getSortedMilestones(rnrState))));
  return {
          currentMilestone: milestoneStatus.contents,
          nextMilestone: nextMilestone.contents,
          secondNextMilestone: secondNextMilestone.contents === nextMilestone.contents ? undefined : secondNextMilestone.contents,
          pointsOfCurrentMilestone: pointsOfCurrentMilestone.contents,
          pointsToNextMilestone: pointsToNextMilestone.contents,
          pointsToSecondNextMilestone: pointsToSecondNextMilestone.contents,
          milestones: milestones,
          awardDisplay: Belt_Option.mapWithDefault(awardOfCurrentMilestone.contents, /* DefaultAward */0, RnrModalsHelper.getValidAward),
          claimedMilestones: getClaimedMilestonesVM,
          showLocked: showLocked.contents
        };
}

export {
  getSortedMilestones ,
  getTotalPoints ,
  getMilestoneVM ,
  
}
/* BadgeUtils Not a pure module */
